import { render, staticRenderFns } from "./changepro.vue?vue&type=template&id=0d2c129a&scoped=true"
import script from "./changepro.vue?vue&type=script&lang=js"
export * from "./changepro.vue?vue&type=script&lang=js"
import style0 from "./changepro.vue?vue&type=style&index=0&id=0d2c129a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c129a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2c129a')) {
      api.createRecord('0d2c129a', component.options)
    } else {
      api.reload('0d2c129a', component.options)
    }
    module.hot.accept("./changepro.vue?vue&type=template&id=0d2c129a&scoped=true", function () {
      api.rerender('0d2c129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/changepro.vue"
export default component.exports